import {getWebsiteMenuInformation_cached_website} from '@data/queries/website/__generated__/getWebsiteMenuInformation_cached'

export default function useProductsLayout(website: getWebsiteMenuInformation_cached_website) {
  if (!website) return 'long'
  return website.productsLayout || 'long'
}
